var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRonDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.12639e-09 2.46135L7.93333 9.13835C8.48101 9.59777 9.22228 9.85569 9.995 9.85569C10.7677 9.85569 11.509 9.59777 12.0567 9.13835L20 2.45362L18.2325 0.966797L10.29 7.65083C10.2119 7.71666 10.1059 7.75364 9.99542 7.75364C9.88493 7.75364 9.77897 7.71666 9.70083 7.65083L1.7675 0.974523L-3.12639e-09 2.46135Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRonDown);
export default __webpack_public_path__ + "static/media/ronDown.1a1a07f8e120f6860d9cf2d19d5a2037.svg";
export { ForwardRef as ReactComponent };